"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var utils_1 = require("../../utils");

var Icon_1 = tslib_1.__importDefault(require("../Icon"));

var styles = tslib_1.__importStar(require("./PriceInfo.style"));

function PriceInfo(_ref) {
  var className = _ref.className,
      salePrice = _ref.salePrice,
      originPrice = _ref.originPrice,
      discountRate = _ref.discountRate,
      caption = _ref.caption,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$isReservable = _ref.isReservable,
      isReservable = _ref$isReservable === void 0 ? true : _ref$isReservable,
      unAvailableReason = _ref.unAvailableReason;
  var isDiscount = originPrice !== 0 && originPrice !== undefined && discountRate !== 0 && discountRate !== undefined;
  return jsx_runtime_1.jsx("div", Object.assign({
    css: [disabled && styles.disabled],
    className: className
  }, {
    children: isReservable ? jsx_runtime_1.jsxs(react_1.Fragment, {
      children: [caption && jsx_runtime_1.jsx("div", Object.assign({
        css: styles.caption
      }, {
        children: caption
      }), void 0), !disabled && isDiscount && jsx_runtime_1.jsxs("div", Object.assign({
        css: styles.discountContainer
      }, {
        children: [jsx_runtime_1.jsxs("span", Object.assign({
          css: styles.discountPrice
        }, {
          children: [utils_1.toCurrency(originPrice || 0), "\uC6D0"]
        }), void 0), jsx_runtime_1.jsxs("span", Object.assign({
          css: styles.discountRate
        }, {
          children: [jsx_runtime_1.jsx(Icon_1.default, {
            name: "ic_sale_xs_red_400",
            alt: "discount"
          }, void 0), discountRate, "%"]
        }), void 0)]
      }), void 0), jsx_runtime_1.jsxs("div", Object.assign({
        css: styles.price
      }, {
        children: [jsx_runtime_1.jsx("span", Object.assign({
          css: styles.pivotText
        }, {
          children: "1\uBC15 \uCD5C\uC800"
        }), void 0), jsx_runtime_1.jsxs("span", Object.assign({
          css: styles.salePrice
        }, {
          children: [utils_1.toCurrency(salePrice), jsx_runtime_1.jsx("span", Object.assign({
            css: styles.salePriceWon
          }, {
            children: "\uC6D0"
          }), void 0)]
        }), void 0)]
      }), void 0)]
    }, void 0) : jsx_runtime_1.jsx("div", Object.assign({
      css: styles.unavailable
    }, {
      children: unAvailableReason || ''
    }), void 0)
  }), void 0);
}

exports.default = react_1.memo(PriceInfo);